import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { EvaporativeCoolerPower } from 'app/model/Device';
import { LocalizationContext, useLocalizedStrings } from 'app/localization/Context';
import RadioButton from 'app/home/general-components/RadioButton/RadioButton';

import { ReactComponent as IconDevicesCoolerFastOff } from 'images/device/status-icon/cooler-fast-off.svg';
import { ReactComponent as IconDevicesCoolerFastOn } from 'images/device/status-icon/cooler-fast-on.svg';
import { ReactComponent as IconDevicesCoolerPowerOff } from 'images/device/status-icon/cooler-power-off.svg';
import { ReactComponent as IconDevicesCoolerPowerOn } from 'images/device/status-icon/cooler-power-on.svg';
import { ReactComponent as IconDevicesCoolerPumpOff } from 'images/device/status-icon/cooler-pump-off.svg';
import { ReactComponent as IconDevicesCoolerPumpOn } from 'images/device/status-icon/cooler-pump-on.svg';
import { ReactComponent as IconDevicesCoolerSlowOff } from 'images/device/status-icon/cooler-slow-off.svg';
import { ReactComponent as IconDevicesCoolerSlowOn } from 'images/device/status-icon/cooler-slow-on.svg';

import { ReactComponent as IconStatusPump } from 'images/device/status-text-icon/pump.svg';
import { ReactComponent as IconStatusStarting } from 'images/device/status-text-icon/starting.svg';
import { ReactComponent as IconStatusSlow } from 'images/device/status-text-icon/slow.svg';
import { ReactComponent as IconStatusFast } from 'images/device/status-text-icon/fast.svg';
import { ReactComponent as IconStatusOn } from 'images/device/status-text-icon/on.svg';

import { ReactComponent as IconStatusPumpFa } from 'images/device/status-text-icon/pump-fa.svg';
import { ReactComponent as IconStatusStartingFa } from 'images/device/status-text-icon/starting-fa.svg';
import { ReactComponent as IconStatusSlowFa } from 'images/device/status-text-icon/slow-fa.svg';
import { ReactComponent as IconStatusFastFa } from 'images/device/status-text-icon/fast-fa.svg';
import { ReactComponent as IconStatusOnFa } from 'images/device/status-text-icon/on-fa.svg';

import { ReactComponent as IconStatusPumpAr } from 'images/device/status-text-icon/pump-ar.svg';
import { ReactComponent as IconStatusStartingAr } from 'images/device/status-text-icon/starting-ar.svg';
import { ReactComponent as IconStatusSlowAr } from 'images/device/status-text-icon/slow-ar.svg';
import { ReactComponent as IconStatusFastAr } from 'images/device/status-text-icon/fast-ar.svg';
import { ReactComponent as IconStatusOnAr } from 'images/device/status-text-icon/on-ar.svg';

import { ReactComponent as IconArrow } from 'images/general/arrow.svg';
import { ReactComponent as IconArrowTall } from 'images/general/arrow-tall.svg';
import { ReactComponent as IconThreeDotsLoadingGray } from 'images/general/three-dots-loading-gray.svg';
import { ReactComponent as IconThreeDotsLoadingGradient } from 'images/general/three-dots-loading-gradient.svg';

import { ReactComponent as IconScenarioCoolerPowerOff } from 'images/scenario/cooler-power-off.svg';
import { ReactComponent as IconScenarioCoolerPowerOn } from 'images/scenario/cooler-power-on.svg';

import './All.scss'

export function CoolerButton({ state, buttonOrder, onClickH, showStates, waitingForChangeState, useCustomSwitchNames }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;

    let deviceIcon = IconDevicesCoolerPowerOn;
    let label = null;
    let additionalIconClass = ""; // " fade-animation-loop";

    if ((state === true) ||
        (state === EvaporativeCoolerPower.on) ||
        (state === EvaporativeCoolerPower.staring) ||
        (!showStates)) {
        if (l.language === 'en') {
            switch (buttonOrder) {
                case 1:
                    if (state === 2) {
                        label = <IconStatusStarting className="status-text-or-icon" />;
                        additionalIconClass = showStates ? " fade-animation-loop" : "";
                    } else {
                        label = <IconStatusOn className="status-text-or-icon" />;
                    }
                    break;
                case 2:
                    label = <IconStatusPump className="status-text-or-icon" />;
                    break;
                case 3:
                    label = <IconStatusSlow className="status-text-or-icon" />;
                    break;
                case 4:
                    label = <IconStatusFast className="status-text-or-icon" />;
                    break;
                default:
                    break;
            }
        } else if (l.language === 'fa') {
            switch (buttonOrder) {
                case 1:
                    if (state === 2) {
                        label = <IconStatusStartingFa className="status-text-or-icon" />;
                        additionalIconClass = showStates ? " fade-animation-loop" : "";
                    } else {
                        label = <IconStatusOnFa className="status-text-or-icon" />;
                    }
                    break;
                case 2:
                    label = <IconStatusPumpFa className="status-text-or-icon" />;
                    break;
                case 3:
                    label = <IconStatusSlowFa className="status-text-or-icon" />;
                    break;
                case 4:
                    label = <IconStatusFastFa className="status-text-or-icon" />;
                    break;
                default:
                    break;
            }
        } else if (l.language === 'ar') {
            switch (buttonOrder) {
                case 1:
                    if (state === 2) {
                        label = <IconStatusStartingAr className="status-text-or-icon" />;
                        additionalIconClass = showStates ? " fade-animation-loop" : "";
                    } else {
                        label = <IconStatusOnAr className="status-text-or-icon" />;
                    }
                    break;
                case 2:
                    label = <IconStatusPumpAr className="status-text-or-icon" />;
                    break;
                case 3:
                    label = <IconStatusSlowAr className="status-text-or-icon" />;
                    break;
                case 4:
                    label = <IconStatusFastAr className="status-text-or-icon" />;
                    break;
                default:
                    break;
            }
        }
        switch (buttonOrder) {
            case 1:
                deviceIcon = IconDevicesCoolerPowerOn;
                break;
            case 2:
                deviceIcon = IconDevicesCoolerPumpOn;
                break;
            case 3:
                deviceIcon = IconDevicesCoolerSlowOn;
                break;
            case 4:
                deviceIcon = IconDevicesCoolerFastOn;
                break;
            default:
                break;
        }
    } else {
        let labelText = s.off;
        switch (buttonOrder) {
            case 1:
                deviceIcon = IconDevicesCoolerPowerOff;
                break;
            case 2:
                deviceIcon = IconDevicesCoolerPumpOff;
                labelText = s.pumpOff;
                break;
            case 3:
                deviceIcon = IconDevicesCoolerSlowOff;
                labelText = s.slowOff;
                break;
            case 4:
                deviceIcon = IconDevicesCoolerFastOff;
                labelText = s.fastOff;
                break;
            default:
                break;
        }

        label = (
            <div className="device-off-label status-text-or-icon">{labelText}</div>
        )
    }

    const shouldShowWaiting = waitingForChangeState && !waitingForChangeState.ignoreWaiting;
    if (shouldShowWaiting) {
        if (state) {
            label = <IconThreeDotsLoadingGradient className="dots-icon" />;
        } else {
            label = <IconThreeDotsLoadingGray className="dots-icon" />;
        }
    }

    if (!showStates) {
        return (
            <div className="device-button">
                {React.createElement(deviceIcon, { className: "device-button-icon-on" + additionalIconClass })}
                <div className="status-placeholder" />
            </div>
        );
    } else {
        return (
            <div className="device-button"
                style={{ width: useCustomSwitchNames ? 70 : 54 }}>
                {/* set width > خاموش, for better placement of buttons and not changing on state changes*/}
                {/* set width to 70, for better display of texts */}
                {React.createElement(deviceIcon, {
                    className: (state ? "device-button-icon-on" : "device-button-icon-off") + additionalIconClass
                })}
                {label}
                <div className="device-on-click-overlay" onClick={onClickH} />
            </div>
        );
    }
}

function Button({
    state, buttonOrder, onClickHandler, darkerBorder, waitingForChangeState,
    useCustomSwitchNames, switchName, customOpacity
}) {
    let c = CoolerButton;
    return (
        <div
            className={"border " + (darkerBorder ? "darker " : "lighter ") + (useCustomSwitchNames ? "named" : "")}
            style={{ opacity: customOpacity }}>
            {React.createElement(c, {
                state, buttonOrder,
                onClickH: onClickHandler, showStates: true,
                switchName, useCustomSwitchNames, waitingForChangeState
            })}
        </div>
    )
}


function CoolerControl({ device, darkerBorder }) {
    const onBoolClickH = useCallback((key) => {
        return (event) => {
            event.preventDefault();
            let changeStateObject = {}
            changeStateObject[key] = !device[key]
            device.changeState(changeStateObject);
        }
    }, [device]);

    const onPowerClick = useCallback((event) => {
        event.preventDefault();
        let changeStateObject = {}
        if (device["power"] === EvaporativeCoolerPower.off) {
            changeStateObject["power"] = EvaporativeCoolerPower.on;
        } else {
            changeStateObject["power"] = EvaporativeCoolerPower.off;
        }
        device.changeState(changeStateObject);
    }, [device]);

    const containerClass = device.active ?
        "device-detail-control with-flex active" : "device-detail-control with-flex inactive";

    return (
        <div className={containerClass}>
            <Button state={device.power} buttonOrder={1}
                onClickHandler={onPowerClick}
                darkerBorder={darkerBorder}
                useCustomSwitchNames={false}
                waitingForChangeState={device.waitingForChangeState["power"]} />
            <Button state={device.pump} buttonOrder={2}
                onClickHandler={onBoolClickH("pump")}
                darkerBorder={darkerBorder}
                useCustomSwitchNames={false}
                waitingForChangeState={device.waitingForChangeState["pump"]} />
            <Button state={device.slow_fan} buttonOrder={3}
                onClickHandler={onBoolClickH("slow_fan")}
                darkerBorder={darkerBorder}
                useCustomSwitchNames={false}
                waitingForChangeState={device.waitingForChangeState["slow_fan"]} />
            <Button state={device.fast_fan} buttonOrder={4}
                onClickHandler={onBoolClickH("fast_fan")}
                darkerBorder={darkerBorder}
                useCustomSwitchNames={false}
                waitingForChangeState={device.waitingForChangeState["fast_fan"]} />
        </div>
    )
}

export function EvaporativeCoolerSettingsChart({ device }) {
    let startFast = device.start_with_fast_mode ? true : false;
    let keepFast = device.keep_fast_mode ? true : false;

    return (
        <div className="cooler-flow-chart">
            <IconDevicesCoolerPowerOn className="icon" />
            <IconArrow className="icon-small arrow" />
            <IconDevicesCoolerPumpOn className="icon" />
            <div className="icon-with-text">
                <IconArrowTall className="icon arrow" />
                <div className="text" dir="ltr">{device.pump_only_duration} s</div>
            </div>
            {startFast ?
                <Fragment>
                    <IconDevicesCoolerFastOn className="icon" />
                    {keepFast ? null : <Fragment>
                        <div className="icon-with-text">
                            <IconArrowTall className="icon arrow" />
                            <div className="text" dir="ltr">{device.fast_mode_duration} s</div>
                        </div>
                        <IconDevicesCoolerSlowOn className="icon" />
                    </Fragment>}
                </Fragment> :
                <IconDevicesCoolerSlowOn className="icon" />}
        </div>
    )
}


export function CoolerScenarioSpecialSlection({ light, setData }) {
    const s = useLocalizedStrings();
    const sc = s.createScenarioProcess;

    const [powerOnC, choosePowerOn] = useState(true);
    const [powerOffC, choosePowerOff] = useState(false);
    const [stateC, chooseState] = useState(false);

    const [intrestedStatePump, setIntrestedStatePump] = useState(false);
    const [intrestedStateFanSlow, setIntrestedStateFanSlow] = useState(false);
    const [intrestedStateFanFast, setIntrestedStateFanFast] = useState(false);
    const intrestedStatePower = intrestedStatePump || intrestedStateFanSlow || intrestedStateFanFast;

    useEffect(() => {
        if (powerOnC) {
            setData({ "power": true }); // affect createBindDeviceSpecialInfoObject function
        } else if (powerOffC) {
            setData({ "power": false });
        } else if (stateC) {
            setData({
                "pump": intrestedStatePump,
                "slow_fan": intrestedStateFanSlow,
                "fast_fan": intrestedStateFanFast,
            });
        }
    }, [powerOnC, powerOffC, stateC, intrestedStatePump, intrestedStateFanSlow, intrestedStateFanFast, setData]);

    const powerOnClickRef = React.createRef();
    const powerOffClickRef = React.createRef();
    const stateClickRef = React.createRef();

    return (
        <div className={"cooler-scenario-special-selection" + (light ? " light" : "")}>
            <div className={"basic-row" + (!powerOnC ? " inactive" : "")} ref={powerOnClickRef} >
                <RadioButton light={light} isOn={powerOnC}
                    setOn={choosePowerOn} setOffOthers={[choosePowerOff, chooseState]}
                    additionalRef={powerOnClickRef} />
                {light ? null : <IconScenarioCoolerPowerOn className="icon" />}
                <div className="title">{sc.powerOn}</div>
            </div>
            <div className={"basic-row" + (!powerOffC ? " inactive" : "")} ref={powerOffClickRef}>
                <RadioButton light={light} isOn={powerOffC}
                    setOn={choosePowerOff} setOffOthers={[choosePowerOn, chooseState]}
                    additionalRef={powerOffClickRef} />
                {light ? null : <IconScenarioCoolerPowerOff className="icon" />}
                <div className="title">{sc.powerOff}</div>
            </div>
            <div className={"cooler-state-row" + (!stateC ? " inactive" : "")} ref={stateClickRef}>
                <RadioButton light={light} isOn={stateC}
                    setOn={chooseState} setOffOthers={[choosePowerOn, choosePowerOff]}
                    additionalRef={stateClickRef} />
                <div className="title">{sc.setThisStateImmediately}</div>

                <div className="cooler-state device-detail-control active">
                    <Button state={intrestedStatePower} buttonOrder={1}
                        onClickHandler={null} customOpacity={0.5}
                        darkerBorder={true} />
                    <Button state={intrestedStatePump} buttonOrder={2}
                        onClickHandler={() => { setIntrestedStatePump(!intrestedStatePump) }}
                        darkerBorder={true} />
                    <Button state={intrestedStateFanSlow} buttonOrder={3}
                        onClickHandler={() => {
                            let newValue = !intrestedStateFanSlow;
                            setIntrestedStateFanSlow(newValue);
                            if (newValue === true)
                                setIntrestedStateFanFast(false);
                        }}
                        darkerBorder={true} />
                    <Button state={intrestedStateFanFast} buttonOrder={4}
                        onClickHandler={() => {
                            let newValue = !intrestedStateFanFast;
                            setIntrestedStateFanFast(newValue);
                            if (newValue === true)
                                setIntrestedStateFanSlow(false);
                        }}
                        darkerBorder={true} />
                </div>
            </div>
        </div>
    );
}

export default CoolerControl;